import AffectedPigGroupsModal from './AffectedPigGroupsModal';

export default AffectedPigGroupsModal;
